import { create } from 'zustand';
import type { User } from './types';

/**
 * Стор текущего юзера.
 * Используется как лёгкий синхронный кэш user для компонентов,
 * которые рендерятся часто (header, sidebar) — не дёргать Query на каждом ререндере.
 *
 * Источник истины — TanStack Query (см. entities/user/api/queries).
 * Этот стор обновляется из onSuccess мутаций и инициализируется при загрузке /me.
 */
interface UserState {
  user: User | null;
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  /** V2-1: обновить баланс аккаунта без перезапроса /user (после ответа, на биллинге). */
  setBalance: (balance: number | string) => void;
  reset: () => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: null,
  isAuthenticated: false,
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  setBalance: (balance) =>
    set((state) => (state.user ? { user: { ...state.user, balance } } : {})),
  reset: () => set({ user: null, isAuthenticated: false }),
}));
